// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "subscriptionDetail-2gC2z";
var _4 = "subscriptionDetail__label-3M7zT";
export { _1 as "__esModule", _2 as "mobile", _3 as "subscriptionDetail", _4 as "subscriptionDetail__label" }
export default { "__esModule": _1, "mobile": _2, "subscriptionDetail": _3, "subscriptionDetail__label": _4 }
